// import { FiX, FiCheckCircle, FiAlertCircle, FiAlertTriangle } from "react-icons/fi";

// const GenericModal = ({
//   open,
//   title,
//   description,
//   children,
//   primaryText = "Confirm",
//   secondaryText = "Cancel",
//   onPrimary,
//   onSecondary,
//   onClose,
//   disableBackdropClose = false,
//   loading = false,
//   type = "default", // success | error | warning | default
// }) => {
//   if (!open) return null;

//   // Determine colors and icon based on type
//   const getTypeStyles = () => {
//     switch (type) {
//       case "success":
//         return {
//           icon: <FiCheckCircle size={24} className="text-green-500" />,
//           borderColor: "border-green-200",
//           titleColor: "text-green-700",
//         };
//       case "error":
//         return {
//           icon: <FiAlertCircle size={24} className="text-red-500" />,
//           borderColor: "border-red-200",
//           titleColor: "text-red-700",
//         };
//       case "warning":
//         return {
//           icon: <FiAlertTriangle size={24} className="text-yellow-500" />,
//           borderColor: "border-yellow-200",
//           titleColor: "text-yellow-700",
//         };
//       default:
//         return {
//           icon: null,
//           borderColor: "border-gray-200",
//           titleColor: "text-gray-900",
//         };
//     }
//   };

//   const typeStyles = getTypeStyles();
//   const isInfoModal = type !== "default" && !onPrimary; // Success/Error/Warning modals with only OK button

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center">

//       <div
//         className="absolute inset-0 bg-black/40"
//         onClick={() => !disableBackdropClose && onClose()}
//       />


//       <div className={`relative bg-white rounded-lg shadow-xl w-full max-w-md mx-4 animate-fadeIn ${typeStyles.borderColor} ${type !== "default" ? "border-l-4" : ""}`}>
  
//         <div className={`flex justify-between items-start px-5 py-3 border-b ${typeStyles.borderColor}`}>
//           <div className="flex items-center gap-3">
//             {typeStyles.icon && <div>{typeStyles.icon}</div>}
//             <h3 className={`text-base font-semibold ${typeStyles.titleColor}`}>{title}</h3>
//           </div>
//           <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
//             <FiX size={18} />
//           </button>
//         </div>


//         <div className="px-5 py-4 text-sm text-gray-600">
//           {description && <p className="mb-3">{description}</p>}
//           {children}
//         </div>

//         <div className="flex justify-end gap-3 px-5 py-2 border-t">
//           {!isInfoModal && (
//             <button
//               className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-md"
//               onClick={onSecondary || onClose}
//               disabled={loading}
//             >
//               {secondaryText}
//             </button>
//           )}

//           <button
//             className={`px-4 py-2 text-sm rounded-md text-white disabled:opacity-60 ${
//               type === "error"
//                 ? "bg-red-500 hover:bg-red-600"
//                 : type === "warning"
//                 ? "bg-yellow-500 hover:bg-yellow-600"
//                 : type === "success"
//                 ? "bg-green-500 hover:bg-green-600"
//                 : "bg-primary hover:bg-primary-dark"
//             }`}
//             onClick={onPrimary || onClose}
//             disabled={loading}
//           >
//             {loading ? "Please wait..." : primaryText}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default GenericModal;

import { FiX, FiCheckCircle, FiAlertCircle, FiAlertTriangle } from "react-icons/fi";
 
const GenericModal = ({
  open,
  title,
  description,
  children,
  primaryText = "Confirm",
  secondaryText = "Cancel",
  onPrimary,
  onSecondary,
  onClose,
  disableBackdropClose = false,
  loading = false,
  type = "default", // success | error | warning | default
}) => {
  if (!open) return null;
 
 
  const isInfoModal = type !== "default" && !onPrimary; // Success/Error/Warning modals with only OK button
 
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center">
 
      <div
        className="absolute inset-0 bg-black/40"
        onClick={() => !disableBackdropClose && onClose()}
      />
 
 
      <div className="relative bg-white rounded-lg shadow-xl w-full max-w-md mx-4 animate-fadeIn">
 
        <div className="flex justify-between items-start px-5 py-3 border-b border-gray-200">
          <h3 className="text-base font-semibold text-gray-900">{title}</h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <FiX size={18} />
          </button>
        </div>
 
 
        <div className="px-5 py-4 text-sm text-gray-600">
          {description && <p className="mb-3">{description}</p>}
          {children}
        </div>
 
        <div className="flex justify-end gap-3 px-5 py-2 border-t">
          {!isInfoModal && (
            <button
              className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-md"
              onClick={onSecondary || onClose}
              disabled={loading}
            >
              {secondaryText}
            </button>
          )}
 
          <button
            className="px-4 py-2 text-sm rounded-md text-white bg-primary hover:bg-primary-dark disabled:opacity-60"
            onClick={onPrimary || onClose}
            disabled={loading}
          >
            {loading ? "Please wait..." : primaryText}
          </button>
        </div>
      </div>
    </div>
  );
};
 
export default GenericModal;